import React from 'react';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98]';
  const variants = {
    primary: 'bg-brand-amber text-white hover:bg-brand-amber-hover shadow-sm',
    secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200',
    ghost: 'hover:bg-gray-100 text-gray-700',
    danger: 'bg-red-50 text-red-600 hover:bg-red-100'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={cn(baseStyles, variants[variant], sizes[size], fullWidth && 'w-full', className)} disabled={disabled || isLoading} {...props} data-id="element-1851">
      {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-1852" />}
      {children}
    </button>;
}